<template>
  <div id="login" class="login">
    <div class="loginTitle">
			<div class="loginTitle_logo" @click="toMenu('/home')"></div>
		</div>
    <div class="loginCont">
      <div class="loginCont_cont">
        <div class="loginCont_cont_cont">
          <div class="loginCon_top">
            <li :class="{loginclass:loginclass===0}" @click="loginclass=0">密码登录</li>
            <!-- <li :class="{loginclass:loginclass===1}" @click="loginclass=1">短信登录</li> -->
          </div>
          <div class="loginbody" v-show="loginclass===0">
            <el-form size="small" :model="form" :rules="formRules" ref="orgDialogForm">
              <div class="loginCont_div"><i class="iconfont icon-denglu"></i>
                <el-form-item prop="email">
                  <el-input placeholder="用户名" v-model="form.email"></el-input>
                </el-form-item>
              </div>
              <div class="loginCont_div"><i class="iconfont icon-mima"></i>
                <el-form-item prop="password">
                  <el-input placeholder="请输入密码" type="password" v-model="form.password"></el-input>
                </el-form-item>
              </div>
              <div class="loginCont_div" style="width:230px;">
                <el-form-item prop="codeB" style="left:0;">
                  <el-input placeholder="请输入图形验证码" v-model="form.codeB"></el-input>
                </el-form-item>
                <div class="login_yzm" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </div>
              <div class="loginCont_div">
                <span><el-checkbox v-model="checked">记住密码</el-checkbox></span>
                <span><a href="##">忘记密码</a></span>
              </div>
              <div class="loginCont_div">
                <div @click="login"><a>登录</a></div>
                <div><router-link :to="{name:'register'}">注册</router-link></div>
              </div>
            </el-form>
          </div>
          <div class="loginbody" v-show="loginclass===1">
            <el-form size="small" :model="form" :rules="formRules" ref="orgDialogForm">
              <div class="loginCont_div loginCont_divC" style="position: relative;top:29px;"><i class="iconfont icon-denglu"></i>
                <el-form-item prop="cell">
                  <el-input placeholder="手机号" v-model="form.cell"></el-input>
                </el-form-item>
              </div>
              <div class="loginCont_div loginCont_divD" style="position: relative;top:67px;"><i class="iconfont  icon-securityCode-b"></i>
                <el-form-item prop="code">
                  <el-input placeholder="验证码" v-model="form.code"></el-input>
                </el-form-item>
                <div  class="login_hq" size="small" @click="getCode" :class="{'closeClick':time!='获取验证码'}">{{time}}<span v-show="time!='获取验证码'">秒后重新获取</span></div>
              </div>
              <div class="loginCont_div" style="width:230px;border:none;">
                <!-- <el-form-item prop="codeB" style="left:0;">
                  <el-input placeholder="请输入图形验证码" v-model="form.codeB"></el-input>
                </el-form-item>
                <div class="login_yzm" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div> -->
              </div>
              <div class="loginCont_div"></div>
              <div class="loginCont_div loginBD">
                <div class="dl" @click="loginB"><a>登录</a></div>
                <div><router-link :to="{name:'register'}">注册</router-link></div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="loginFoot">
      © 中国 北京 2015.11      沪ICP备05015387号    互联网出版许可证
    </div>
  </div>
</template>

<script>
import util from '../../assets/script/util'
import SIdentify  from '../sidentify'
import axios from 'axios'
import validate from '../../assets/script/validate';
import router from '@/router/index'
import $ from 'jquery'
import { pagination } from '../../../src/assets/mixin/data-table'
export default {
  name:'login',
  data(){
    const VALIDATE_EMAIL = (rule, value, callback) => {
      if (util.isNotEmpty(value) && !validate.validateEmail(value)) {
        callback(new Error('Email需合法'));
      } else {
        callback();
      }
    };
    const VALIDATE_PASSWORD = (rule, value, callback) => {
      if (util.isNotEmpty(value) && !validate.validatePassword(value)) {
        callback(new Error('密码需为6-20位字符'));
      } else {
        callback();
      }
    };
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (util.isNotEmpty(value) && !validate.validateMobile(value)) {
        callback(new Error('手机号需为11位数字'));
      } else {
        callback();
      }
    };
    return{
      time:"获取验证码",
      loginclass:0,
      form:{
        email:'',
        password:'',
        cell:'',
        code:''
      },
      formRules: {
        cell: [{ validator: VALIDATE_MOBILE_NO, trigger: 'blur' }],
        email: [{ validator: VALIDATE_EMAIL, trigger: 'blur' }],
        password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {validator: VALIDATE_PASSWORD, trigger: 'blur' }
        ],
        codeB: [
          {
            required: true,
            message: '请输入图形验证码',
            trigger: 'change'
          }
        ],
      },
      isShow:false,
      checked:false,
      identifyCodes: "1234567890",
      identifyCode: "",
    }
  },
  components:{
    SIdentify,
  },
  methods:{
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    onMouseOver(){
      this.isShow = true;
    },
    onMouseOut(){
      this.isShow = false
    },
    // 验证码
    gettime(){
      if(this.time == 0){
        clearInterval(this.close);
        this.time = '获取验证码';
      } else {
        this.time--;
      }
    },
    toMenu(url){
      this.$router.push({
        path:url
      })
    },
    // 获取验证码
    getCode(){
      axios.get('/api/Lm/GetVerifyPhone?phone='+this.form.cell).then((res) => {
        if(res.data.Content != '手机号不存在'){
          axios.get('/api/Lm/GetNoteVc?smsMob='+this.form.cell).then((res) => {
            if(res.status == 200){
              this.time = 60;
              this.close = setInterval(this.gettime,1000);
            } else {
              this.$message({
                message: '信息发送失败',
                type: 'warning'
              });
            }
          }).catch((e) => {
            console.log(e);
          })
        } else {
          this.$message({
            message:'该账号不存在',
            type:'error'
          });
        }
      }).catch((e) => {
        console.log(e);
      })
    },
    // 登录
    login(){
      localStorage.setItem('userName', this.form.email);
      localStorage.setItem('psw',this.form.password)
      var makeCode =  localStorage.getItem('makeCode');
      if (this.checked == true) {
        this.setCookie(this.form.email, this.form.password, 24 * 60 * 60 * 1000 * 1);
      } else {
        this.clearCookie();
        this.form.email == '';
        this.form.password == ''
      }
      // if(this.identifyCode !== this.form.codeB){
      //   this.form.codeB = '';
      //   this.refreshCode();
      //   alert('请输入正确的验证码');
      // }
      this.$refs.orgDialogForm.validate(valid => {
        if(valid) {
          axios.post('/authorapi/loginapi',{
            JournalID:'202007100001',
            LoginName:this.form.email,
            Pwd:this.form.password
          }).then((res) => {
            if(res.data.code = '000000'){
              let infon = {userName: this.form.email}
              for(var key in infon){
                this.set(key,infon[key]);
              }
              // localStorage.setItem('AuthorId',res.data.Data.AuthorId)
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              this.$router.push({
                path: '/home'
              });
            } else {
              if(this.form.codeB = ''){
                this.$message({
                  message:'请输入验证码',
                  type:'error'
                });
              }
              else {
                this.$message({
                  message:'账号或者密码错误',
                  type:'error'
                });
              }
            }
          }).catch(({ msg }) => {
            this.$message({
              type: 'error',
              message: msg
            });
          })
        } else {
          if (this.form.email == '') {
            this.$message({
              message: '请输入邮箱',
              type: 'warning'
            });
            return false;
          }
          if (this.form.password == '') {
            this.$message({
              message: '请输入密码',
              type: 'warning'
            });
            return false;
          }
          if (this.form.codeB == '') {
            this.$message({
              message: '请输入图形验证码',
              type: 'warning'
            });
            return false;
          }
          if(this.form.codeB != makeCode){
            this.$message({
              message: '请输入正确的图形验证码',
              type: 'warning'
            });
            return false;
          }
        }
        // if(this.identifyCode !== this.form.codeB){
        //   this.form.codeB = '';
        //   this.refreshCode();
        //   alert('请输入正确的验证码');
        // }
      })
    },
    loginB(){
      this.$refs.orgDialogForm.validate(valid => {
        if (this.form.code == '') {
          this.$message({
            message: '请输入验证码',
            type: 'warning'
          });
          return false;
        } else {
          this.$router.push({
            path:'/home'
          })
        }
      })
    },
    // 设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "c_name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "c_pwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    // 获取cookie
    getCookie: function(key) {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值            z   ,2
          if (arr2[0] == "c_name") {
            this.form.email = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "c_pwd") {
            this.form.password = arr2[1];
          }
        }
      }
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    set(key,value){
      var curTime = new Date().getTime();
      localStorage.setItem(key,JSON.stringify({data:value,time:curTime}));
    }
  },
  mounted(){
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    localStorage.setItem('makeCode',this.identifyCode);
  },
  created(){
    this.refreshCode();
    this.getCookie();
  }
}
</script>

<style lang="less" scoped>
  #login{
    width:100%;
    height:100%;
    background-size:cover;
    .loginTitle{
			width:1200px;
			height:66px;
			margin:0 auto;
			margin-top:46px;
			.loginTitle_logo{
				float: left;
				width: 748px;
				height: 66px;
				margin-left: 30px;
				background: url('../../../static/logo.png')no-repeat;
        background-size: cover;
        cursor:pointer;
			}
    }
    .loginFoot{
      width: 335px;
      height: 15px;
      margin: 0 auto;
      position: relative;
      margin-top:29px;
    }
    .loginCont{
      width:100%;
      height:620px;
      position:relative;
      background:url('../../../static/注册页_02.png')no-repeat;
      background-size:cover;
      margin-top:28px;
      .loginCont_cont{
        width:1140px;
        height:100%;
        margin: 0 auto;
        position: relative;
        .loginCont_cont_cont{
          width:489px;
          height:382px;
          background:#fff;
          position:absolute;
          top:70px;
          right: 0;
        }
      }
      .loginCon_top{
        width: 100%;
        height: 66px;
        border-bottom: 1px solid #DFDFDF;
        li{
          list-style: none;
          float: left;
          width: 73px;
          height: 40px;
          color: #CBCBCB;
          font-size: 18px;
          text-align: center;
          line-height: 30px;
          margin-top: 26px;
          // margin-left: 99px;
          margin-left: 198px;
          font-weight: bold;
          cursor: pointer;
        }
        .loginclass{
          color: #C01B22;
          border-bottom: 1px solid #C01B22;
        }
        li:nth-child(2){
          margin-left: 37px;
        }
      }
      .loginbody{
        width: 332px;
        height: 251px;
        margin-top: 22px;
        margin-left:79px;
        .loginCont_div{
          width:332px;
          height:37px;
          border:1px solid #CBCBCB;
          margin-bottom:17px;
          border-radius:5px;
          position: relative;
          i{
            color:#CBCBCB;
            font-size:20px;
            position: relative;
            top: 3px;
            margin-left:19px;
          }
          .login_hq{
            width: 92px;
            height:35px;
            background:#C01B22;
            line-height:35px;
            text-align:center;
            color:#fff;
            font-size:16px;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            border-radius:0 5px 5px 0;
          }
        }
        .loginCont_div:nth-child(3){
          .login_yzm{
            width: 92px;
            height: 35px;
            cursor: pointer;
            right: -104px;
            top: 0;
            position: absolute;
            em{
              letter-spacing: 6px;
            }
          }
        }
        .loginCont_div:nth-child(4){
          line-height:37px;
          border:none;
          span:nth-child(1){
            float: left;
            color:#656565;
            font-size: 14px;
          }
          span:nth-child(2){
            float: right;
            a{
              color:#9B9B9B;
              font-size: 14px;
            }
          }
          span:nth-child(2):hover{
            a{
              color: #C01B22;
            }
          }
        }
        .loginCont_div:nth-child(5){
          border:none;
          text-align: center;
          line-height: 35px;
          div:nth-child(1){
            width: 207px;
            height: 35px;
            background: #C01B22;
            border-radius:5px;
            float: left;
            a{
              color:#FFFFFF;
              font-size: 18px;
            }
          }
          div:nth-child(2){
            width: 115px;
            height: 35px;
            border-radius:5px;
            border:1px solid #CBCBCB;
            float: right;
            a{
              color:#898989;
              font-size: 18px;
            }
          }
        }
      }
      .loginbody_code{
        width: 489px;
        height: 382px;
        position: relative;
        top: -339px;
        background: #fff;
        border-radius: 5px;
        z-index: 999;
        .loginbody_code_img{
          width: 231px;
          height: 250px;
          margin-left: 129px;
          position: relative;
          top: 57px;
          p{
            color: #000;
            font-size: 18px;
            text-align: center;
          }
          img{
            width: 231px;
            height: 231px;
          }
        }
      }
    }
  }
  /deep/.el-input__inner{
    height:35px!important;
    line-height:35px!important;
    border:1px solid #fff!important;
  }
  /deep/.el-form-item{
    width:86%;
    position: absolute;
    left: 46px;
    top: 0;
  }
  /deep/.el-form-item__content{
    line-height:34px;
  }
  /deep/.el-input{
    width: 87%;
    outline:none;
    border:none;
  }
  .loginCon_top:hover{
    .dl{
      display: none;
    }
  }
  /deep/.el-form-item.is-error .el-input__inner{
    border-color:#fff;
  }

  @media screen and (max-width:1010px){
    .loginTitle{
      display:none;
    }
    #mofootBase{
      margin-top: 65px;
    }
    .loginFoot{
      display:none;
    }
    .loginCont{
      position: relative;
      top: 40px;
      background: #fff!important;
      height: 370px!important;
    }
    .loginCont_cont_cont{
      width:83%!important;
      margin:0 auto;
      position: relative!important;
      top: 0px!important;
    }
    .loginCont_cont{
      width:100%!important;
    }
    .loginbody_code{
      display:none;
    }
    .codeLogin{
      display: none;
    }
    .loginCon_top{
      li:nth-child(1){
        margin-left: 34px!important;
      }
      li:nth-child(2){
        margin-left: 87px!important;
      }
    }
    .loginbody{
      width:100%!important;
      margin-left: 0px!important;
    }
    /deep/.el-form{
      width:100%!important;
      .loginCont_div{
        width: 100%!important;
      }
      .loginCont_div:nth-child(3){
        width:175px!important;
      }
      .loginCont_div:nth-child(5){
        div{
          width: 48%!important;
        }
      }
      .loginCont_divC{
        top:0px!important;
      }
      .loginCont_divD{
        top:0px!important;
      }
    }
    .loginBD{
      position: relative;
      top: -91px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue